/**
 * Capitalizes the given string
 */
export const capitalize = (str: string) =>
  str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()

/**
 * Capitalizes all words in the given string
 */
export const capitalizeAllWords = (str: string) =>
  str.split(' ').map(capitalize).join(' ')

/**
 * Converts object properties from snake_case to camelCase
 */
export const convertSnakeToCamelCase = (obj: object) => {
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const newKey = key.replace(/(_\w)/g, (m) => {
        return m[1].toUpperCase()
      })

      if (newKey !== key) {
        obj[newKey as keyof typeof obj] = obj[key as keyof typeof obj]
        delete obj[key as keyof typeof obj]
      }
    }
  }

  return obj
}
/**
 * Converts string into pascalCase
 */
export const toPascalCase = (str: string) =>
  str
    .split(' ')
    .map((word) => word[0].toUpperCase().concat(word.slice(1)))
    .join('')

/**
 * Checks whether the search value matches (including partial matches) the provided string
 * @param str - provided string
 * @param searchVal - search value
 * @returns True if there is a match
 */
export const matchSearchString = (str: string, searchVal: string) => {
  return searchVal
    .toLowerCase()
    .split(' ')
    .every((searchWord) =>
      str.split(' ').some((word) => word.toLowerCase().includes(searchWord)),
    )
}
